export const DripIcons = [
  'dripicons-alarm',
  'dripicons-align-center',
  'dripicons-align-justify',
  'dripicons-align-left',
  'dripicons-align-right',
  'dripicons-anchor',
  'dripicons-archive',
  'dripicons-arrow-down',
  'dripicons-arrow-left',
  'dripicons-arrow-right',
  'dripicons-arrow-thin-down',
  'dripicons-arrow-thin-left',
  'dripicons-arrow-thin-right',
  'dripicons-arrow-thin-up',
  'dripicons-arrow-up',
  'dripicons-article',
  'dripicons-backspace',
  'dripicons-basket',
  'dripicons-basketball',
  'dripicons-battery-empty',
  'dripicons-battery-full',
  'dripicons-battery-low',
  'dripicons-battery-medium',
  'dripicons-bell',
  'dripicons-blog',
  'dripicons-bluetooth',
  'dripicons-bold',
  'dripicons-bookmark',
  'dripicons-bookmarks',
  'dripicons-box',
  'dripicons-briefcase',
  'dripicons-brightness-low',
  'dripicons-brightness-max',
  'dripicons-brightness-medium',
  'dripicons-broadcast',
  'dripicons-browser',
  'dripicons-browser-upload',
  'dripicons-brush',
  'dripicons-calendar',
  'dripicons-camcorder',
  'dripicons-camera',
  'dripicons-card',
  'dripicons-cart',
  'dripicons-checklist',
  'dripicons-checkmark',
  'dripicons-chevron-down',
  'dripicons-chevron-left',
  'dripicons-chevron-right',
  'dripicons-chevron-up',
  'dripicons-clipboard',
  'dripicons-clock',
  'dripicons-clockwise',
  'dripicons-cloud',
  'dripicons-cloud-download',
  'dripicons-cloud-upload',
  'dripicons-code',
  'dripicons-contract',
  'dripicons-contract-2',
  'dripicons-conversation',
  'dripicons-copy',
  'dripicons-crop',
  'dripicons-cross',
  'dripicons-crosshair',
  'dripicons-cutlery',
  'dripicons-device-desktop',
  'dripicons-device-mobile',
  'dripicons-device-tablet',
  'dripicons-direction',
  'dripicons-disc',
  'dripicons-document',
  'dripicons-document-delete',
  'dripicons-document-edit',
  'dripicons-document-new',
  'dripicons-document-remove',
  'dripicons-dot',
  'dripicons-dots-2',
  'dripicons-dots-3',
  'dripicons-download',
  'dripicons-duplicate',
  'dripicons-enter',
  'dripicons-exit',
  'dripicons-expand',
  'dripicons-expand-2',
  'dripicons-experiment',
  'dripicons-export',
  'dripicons-feed',
  'dripicons-flag',
  'dripicons-flashlight',
  'dripicons-folder',
  'dripicons-folder-open',
  'dripicons-forward',
  'dripicons-gaming',
  'dripicons-gear',
  'dripicons-graduation',
  'dripicons-graph-bar',
  'dripicons-graph-line',
  'dripicons-graph-pie',
  'dripicons-headset',
  'dripicons-heart',
  'dripicons-help',
  'dripicons-home',
  'dripicons-hourglass',
  'dripicons-inbox',
  'dripicons-information',
  'dripicons-italic',
  'dripicons-jewel',
  'dripicons-lifting',
  'dripicons-lightbulb',
  'dripicons-link',
  'dripicons-link-broken',
  'dripicons-list',
  'dripicons-loading',
  'dripicons-location',
  'dripicons-lock',
  'dripicons-lock-open',
  'dripicons-mail',
  'dripicons-map',
  'dripicons-media-loop',
  'dripicons-media-next',
  'dripicons-media-pause',
  'dripicons-media-play',
  'dripicons-media-previous',
  'dripicons-media-record',
  'dripicons-media-shuffle',
  'dripicons-media-stop',
  'dripicons-medical',
  'dripicons-menu',
  'dripicons-message',
  'dripicons-meter',
  'dripicons-microphone',
  'dripicons-minus',
  'dripicons-monitor',
  'dripicons-move',
  'dripicons-music',
  'dripicons-network-1',
  'dripicons-network-2',
  'dripicons-network-3',
  'dripicons-network-4',
  'dripicons-network-5',
  'dripicons-pamphlet',
  'dripicons-paperclip',
  'dripicons-pencil',
  'dripicons-phone',
  'dripicons-photo',
  'dripicons-photo-group',
  'dripicons-pill',
  'dripicons-pin',
  'dripicons-plus',
  'dripicons-power',
  'dripicons-preview',
  'dripicons-print',
  'dripicons-pulse',
  'dripicons-question',
  'dripicons-reply',
  'dripicons-reply-all',
  'dripicons-return',
  'dripicons-retweet',
  'dripicons-rocket',
  'dripicons-scale',
  'dripicons-search',
  'dripicons-shopping-bag',
  'dripicons-skip',
  'dripicons-stack',
  'dripicons-star',
  'dripicons-stopwatch',
  'dripicons-store',
  'dripicons-suitcase',
  'dripicons-swap',
  'dripicons-tag',
  'dripicons-tag-delete',
  'dripicons-tags',
  'dripicons-thumbs-down',
  'dripicons-thumbs-up',
  'dripicons-ticket',
  'dripicons-time-reverse',
  'dripicons-to-do',
  'dripicons-toggles',
  'dripicons-trash',
  'dripicons-trophy',
  'dripicons-upload',
  'dripicons-user',
  'dripicons-user-group',
  'dripicons-user-id',
  'dripicons-vibrate',
  'dripicons-view-apps',
  'dripicons-view-list',
  'dripicons-view-list-large',
  'dripicons-view-thumb',
  'dripicons-volume-full',
  'dripicons-volume-low',
  'dripicons-volume-medium',
  'dripicons-volume-off',
  'dripicons-wallet',
  'dripicons-warning',
  'dripicons-web',
  'dripicons-weight',
  'dripicons-wifi',
  'dripicons-wrong',
  'dripicons-zoom-in',
  'dripicons-zoom-out',
];

export const BoxIcons = [
  'bx bx-sticker',
  'bx bx-shield-quarter',
  'bx bx-upside-down',
  'bx bx-laugh',
  'bx bx-meh-blank',
  'bx bx-happy-beaming',
  'bx bx-shocked',
  'bx bx-sleepy',
  'bx bx-confused',
  'bx bx-wink-smile',
  'bx bx-dizzy',
  'bx bx-happy-heart-eyes',
  'bx bx-angry',
  'bx bx-smile',
  'bx bx-tired',
  'bx bx-cool',
  'bx bx-happy-alt',
  'bx bx-wink-tongue',
  'bx bx-meh-alt',
  'bx bx-food-menu',
  'bx bx-food-tag',
  'bx bx-female-sign',
  'bx bx-male-sign',
  'bx bx-female',
  'bx bx-male',
  'bx bx-clinic',
  'bx bx-health',
  'bx bx-shekel',
  'bx bx-yen',
  'bx bx-won',
  'bx bx-pound',
  'bx bx-euro',
  'bx bx-rupee',
  'bx bx-ruble',
  'bx bx-lira',
  'bx bx-bitcoin',
  'bx bx-tone',
  'bx bx-bolt-circle',
  'bx bx-cake',
  'bx bx-spa',
  'bx bx-dish',
  'bx bx-fridge',
  'bx bx-image-add',
  'bx bx-image-alt',
  'bx bx-space-bar',
  'bx bx-alarm-add',
  'bx bx-archive-out',
  'bx bx-archive-in',
  'bx bx-add-to-queue',
  'bx bx-border-radius',
  'bx bx-check-shield',
  'bx bx-label',
  'bx bx-file-find',
  'bx bx-face',
  'bx bx-extension',
  'bx bx-exit',
  'bx bx-conversation',
  'bx bx-sort-z-a',
  'bx bx-sort-a-z',
  'bx bx-printer',
  'bx bx-radio',
  'bx bx-customize',
  'bx bx-brush-alt',
  'bx bx-briefcase-alt-2',
  'bx bx-time-five',
  'bx bx-pie-chart-alt-2',
  'bx bx-gas-pump',
  'bx bx-mobile-vibration',
  'bx bx-mobile-landscape',
  'bx bx-border-all',
  'bx bx-border-bottom',
  'bx bx-border-top',
  'bx bx-border-left',
  'bx bx-dialpad-alt',
  'bx bx-filter-alt',
  'bx bx-brightness',
  'bx bx-brightness-half',
  'bx bx-wifi-off',
  'bx bx-credit-card-alt',
  'bx bx-band-aid',
  'bx bx-hive',
  'bx bx-map-pin',
  'bx bx-line-chart',
  'bx bx-receipt',
  'bx bx-purchase-tag-alt',
  'bx bx-basket',
  'bx bx-palette',
  'bx bx-no-entry',
  'bx bx-message-alt-dots',
  'bx bx-message-alt',
  'bx bx-check-square',
  'bx bx-log-out-circle',
  'bx bx-log-in-circle',
  'bx bx-doughnut-chart',
  'bx bx-building-house',
  'bx bx-accessibility',
  'bx bx-user-voice',
  'bx bx-cuboid',
  'bx bx-cube-alt',
  'bx bx-polygon',
  'bx bx-square-rounded',
  'bx bx-square',
  'bx bx-error-alt',
  'bx bx-shield-alt-2',
  'bx bx-paint-roll',
  'bx bx-droplet',
  'bx bx-street-view',
  'bx bx-plus-medical',
  'bx bx-search-alt-2',
  'bx bx-bowling-ball',
  'bx bx-dna',
  'bx bx-cycling',
  'bx bx-shape-circle',
  'bx bx-down-arrow-alt',
  'bx bx-up-arrow-alt',
  'bx bx-right-arrow-alt',
  'bx bx-left-arrow-alt',
  'bx bx-lock-open-alt',
  'bx bx-lock-alt',
  'bx bx-cylinder',
  'bx bx-pyramid',
  'bx bx-comment-dots',
  'bx bx-comment',
  'bx bx-landscape',
  'bx bx-book-open',
  'bx bx-transfer-alt',
  'bx bx-copy-alt',
  'bx bx-run',
  'bx bx-user-pin',
  'bx bx-grid',
  'bx bx-code-alt',
  'bx bx-mail-send',
  'bx bx-ghost',
  'bx bx-shape-triangle',
  'bx bx-shape-square',
  'bx bx-video-recording',
  'bx bx-notepad',
  'bx bx-bug-alt',
  'bx bx-mouse-alt',
  'bx bx-edit-alt',
  'bx bx-chat',
  'bx bx-book-content',
  'bx bx-message-square-dots',
  'bx bx-message-square',
  'bx bx-slideshow',
  'bx bx-wallet-alt',
  'bx bx-memory-card',
  'bx bx-message-rounded-dots',
  'bx bx-message-dots',
  'bx bx-bar-chart-alt-2',
  'bx bx-store-alt',
  'bx bx-buildings',
  'bx bx-home-circle',
  'bx bx-money',
  'bx bx-walk',
  'bx bx-repeat',
  'bx bx-font-family',
  'bx bx-joystick-button',
  'bx bx-paint',
  'bx bx-unlink',
  'bx bx-brush',
  'bx bx-rotate-left',
  'bx bx-badge-check',
  'bx bx-show-alt',
  'bx bx-caret-down',
  'bx bx-caret-right',
  'bx bx-caret-up',
  'bx bx-caret-left',
  'bx bx-calendar-event',
  'bx bx-magnet',
  'bx bx-rewind-circle',
  'bx bx-card',
  'bx bx-help-circle',
  'bx bx-test-tube',
  'bx bx-note',
  'bx bx-sort-down',
  'bx bx-sort-up',
  'bx bx-id-card',
  'bx bx-badge',
  'bx bx-grid-small',
  'bx bx-grid-vertical',
  'bx bx-grid-horizontal',
  'bx bx-move-vertical',
  'bx bx-move-horizontal',
  'bx bx-stats',
  'bx bx-equalizer',
  'bx bx-disc',
  'bx bx-analyse',
  'bx bx-search-alt',
  'bx bx-dollar-circle',
  'bx bx-football',
  'bx bx-ball',
  'bx bx-circle',
  'bx bx-transfer',
  'bx bx-fingerprint',
  'bx bx-font-color',
  'bx bx-highlight',
  'bx bx-file-blank',
  'bx bx-strikethrough',
  'bx bx-photo-album',
  'bx bx-code-block',
  'bx bx-font-size',
  'bx bx-handicap',
  'bx bx-dialpad',
  'bx bx-wind',
  'bx bx-water',
  'bx bx-swim',
  'bx bx-restaurant',
  'bx bx-box',
  'bx bx-menu-alt-right',
  'bx bx-menu-alt-left',
  'bx bx-video-plus',
  'bx bx-list-ol',
  'bx bx-planet',
  'bx bx-hotel',
  'bx bx-movie',
  'bx bx-taxi',
  'bx bx-time',
  'bx bx-briefcase',
  'bx bx-bug',
  'bx bx-world',
  'bx bx-user',
  'bx bx-layer',
  'bx bx-calendar',
  'bx bx-bookmark-alt',
  'bx bx-camera',
  'bx bx-car',
  'bx bx-chat',
  'bx bx-coin-stack',
  'bx bx-comment',
  'bx bx-compass',
  'bx bx-crown',
  'bx bx-desktop',
  'bx bx-diamond',
  'bx bx-envelope',
  'bx bx-gift',
  'bx bx-globe',
  'bx bx-group',
  'bx bx-headphone',
  'bx bx-heart',
  'bx bx-home',
  'bx bx-image',
  'bx bx-joystick',
  'bx bx-landmark',
  'bx bx-like',
  'bx bx-lock-alt',
  'bx bx-map',
  'bx bx-medal',
  'bx bx-message',
  'bx bx-microphone',
  'bx bx-money',
  'bx bx-paint',
  'bx bx-palette',
  'bx bx-paper-plane',
  'bx bx-parking',
  'bx bx-pencil',
  'bx bx-phone',
  'bx bx-pie-chart',
  'bx bx-planet',
  'bx bx-rocket',
  'bx bx-shield',
  'bx bx-shipping',
  'bx bx-shopping-bag',
  'bx bx-spreadsheet',
  'bx bx-star',
  'bx bx-support',
  'bx bx-table',
  'bx bx-target-lock',
  'bx bx-telephone',
  'bx bx-thermometer',
  'bx bx-timer',
  'bx bx-trophy',
  'bx bx-tv',
  'bx bx-user-check',
  'bx bx-user-minus',
  'bx bx-user-plus',
  'bx bx-user-voice',
  'bx bx-webcam',
  'bx bx-window-close',
  'bx bx-window-open',
  'bx bx-wrench',
  'bx bx-zoom-in',
  'bx bx-zoom-out',
  'bx bx-zoom-in',
  'bx bx-x-circle',
  'bx bx-volume',
  'bx bx-volume-mute',
  'bx bx-volume-low',
  'bx bx-volume-full',
  'bx bx-video',
  'bx bx-vertical-center',
  'bx bx-up-arrow-circle',
  'bx bx-trending-up',
  'bx bx-trending-down',
  'bx bx-toggle-right',
  'bx bx-toggle-left',
  'bx bx-time',
  'bx bx-sync',
  'bx bx-stopwatch',
  'bx bx-stop',
  'bx bx-stop-circle',
  'bx bx-skip-previous',
  'bx bx-skip-next',
  'bx bx-show',
  'bx bx-search',
  'bx bx-rss',
  'bx bx-right-top-arrow-circle',
  'bx bx-right-indent',
  'bx bx-right-down-arrow-circle',
  'bx bx-right-arrow-circle',
  'bx bx-reset',
  'bx bx-rewind',
  'bx bx-rectangle',
  'bx bx-radio-circle',
  'bx bx-radio-circle-marked',
  'bx bx-question-mark',
  'bx bx-plus-circle',
  'bx bx-play',
  'bx bx-play-circle',
  'bx bx-pause',
  'bx bx-pause-circle',
  'bx bx-moon',
  'bx bx-minus-circle',
  'bx bx-microphone',
  'bx bx-menu',
  'bx bx-left-top-arrow-circle',
  'bx bx-left-indent',
  'bx bx-left-down-arrow-circle',
  'bx bx-left-arrow-circle',
  'bx bx-last-page',
  'bx bx-key',
  'bx bx-align-justify',
  'bx bx-info-circle',
  'bx bx-image',
  'bx bx-hide',
  'bx bx-fullscreen',
  'bx bx-folder',
  'bx bx-folder-plus',
  'bx bx-folder-minus',
  'bx bx-first-page',
  'bx bx-fast-forward',
  'bx bx-fast-forward-circle',
  'bx bx-exit-fullscreen',
  'bx bx-error',
  'bx bx-error-circle',
  'bx bx-down-arrow-circle',
  'bx bx-copyright',
  'bx bx-copy',
  'bx bx-coffee',
  'bx bx-code',
  'bx bx-code-curly',
  'bx bx-clipboard',
  'bx bx-chevrons-left',
  'bx bx-chevrons-right',
  'bx bx-chevrons-up',
  'bx bx-chevrons-down',
  'bx bx-chevron-right',
  'bx bx-chevron-left',
  'bx bx-chevron-up',
  'bx bx-chevron-down',
  'bx bx-checkbox-square',
  'bx bx-checkbox',
  'bx bx-checkbox-checked',
  'bx bx-captions',
  'bx bx-camera',
  'bx bx-camera-off',
  'bx bx-bullseye',
  'bx bx-bookmarks',
  'bx bx-bookmark',
  'bx bx-bell',
  'bx bx-bell-plus',
  'bx bx-bell-off',
  'bx bx-bell-minus',
  'bx bx-arrow-back',
  'bx bx-align-right',
  'bx bx-align-middle',
  'bx bx-align-left',
];


export const MaterialIUIcon = [
    "Abc",
    "AcUnit",
    "AccessAlarm",
    "AccessAlarms",
    "AccessTime",
    "AccessTimeFilled",
    "Accessibility",
    "AccessibilityNew",
    "Accessible",
    "AccessibleForward",
    "AccountBalance",
    "AccountBalanceWallet",
    "AccountBox",
    "AccountCircle",
    "AccountTree",
    "AdUnits",
    "Adb",
    "Add",
    "AddAPhoto",
    "AddAlarm",
    "AddAlert",
    "AddBox",
    "AddBusiness",
    "AddCard",
    "AddCircle",
    "AddCircleOutline",
    "AddComment",
    "AddHome",
    "AddHomeWork",
    "AddIcCall",
    "AddLink",
    "AddLocation",
    "AddLocationAlt",
    "AddModerator",
    "AddPhotoAlternate",
    "AddReaction",
    "AddRoad",
    "AddShoppingCart",
    "AddTask",
    "AddToDrive",
    "AddToHomeScreen",
    "AddToPhotos",
    "AddToQueue",
    "Addchart",
    "AdfScanner",
    "Adjust",
    "AdminPanelSettings",
    "AdsClick",
    "Agriculture",
    "Air",
    "AirlineSeatFlat",
    "AirlineSeatFlatAngled",
    "AirlineSeatIndividualSuite",
    "AirlineSeatLegroomExtra",
    "AirlineSeatLegroomNormal",
    "AirlineSeatLegroomReduced",
    "AirlineSeatReclineExtra",
    "AirlineSeatReclineNormal",
    "AirlineStops",
    "Airlines",
    "AirplaneTicket",
    "AirplanemodeActive",
    "AirplanemodeInactive",
    "Airplay",
    "AirportShuttle",
    "Alarm",
    "AlarmAdd",
    "AlarmOff",
    "AlarmOn",
    "Album",
    "AlignHorizontalCenter",
    "AlignHorizontalLeft",
    "AlignHorizontalRight",
    "AlignVerticalBottom",
    "AlignVerticalCenter",
    "AlignVerticalTop",
    "AllInbox",
    "AllInclusive",
    "AllOut",
    "AltRoute",
    "AlternateEmail",
    "Analytics",
    "Anchor",
    "Android",
    "Animation",
    "Announcement",
    "Aod",
    "Apartment",
    "Api",
    "AppBlocking",
    "AppRegistration",
    "AppSettingsAlt",
    "AppShortcut",
    "Apple",
    "Approval",
    "Apps",
    "AppsOutage",
    "Architecture",
    "Archive",
    "ArrowBack",
    "ArrowBackIos",
    "ArrowBackIosNew",
    "ArrowCircleDown",
    "ArrowCircleLeft",
    "ArrowCircleRight",
    "ArrowCircleUp",
    "ArrowDownward",
    "ArrowDropDown",
    "ArrowDropDownCircle",
    "ArrowDropUp",
    "ArrowForward",
    "ArrowForwardIos",
    "ArrowLeft",
    "ArrowOutward",
    "ArrowRight",
    "ArrowRightAlt",
    "ArrowUpward",
    "ArtTrack",
    "Article",
    "AspectRatio",
    "Assessment",
    "Assignment",
    "AssignmentInd",
    "AssignmentLate",
    "AssignmentReturn",
    "AssignmentReturned",
    "AssignmentTurnedIn",
    "AssistWalker",
    "Assistant",
    "AssistantDirection",
    "AssistantPhoto",
    "AssuredWorkload",
    "Atm",
    "AttachEmail",
    "AttachFile",
    "AttachMoney",
    "Attachment",
    "Attractions",
    "Attribution",
    "AudioFile",
    "Audiotrack",
    "AutoAwesome",
    "AutoAwesomeMosaic",
    "AutoAwesomeMotion",
    "AutoDelete",
    "AutoFixHigh",
    "AutoFixNormal",
    "AutoFixOff",
    "AutoGraph",
    "AutoMode",
    "AutoStories",
    "AutofpsSelect",
    "Autorenew",
    "AvTimer",
    "BabyChangingStation",
    "BackHand",
    "Backpack",
    "Backspace",
    "Backup",
    "BackupTable",
    "Badge",
    "BakeryDining",
    "Balance",
    "Balcony",
    "Ballot",
    "BarChart",
    "BatchPrediction",
    "Bathroom",
    "Bathtub",
    "Battery0Bar",
    "Battery1Bar",
    "Battery20",
    "Battery2Bar",
    "Battery30",
    "Battery3Bar",
    "Battery4Bar",
    "Battery50",
    "Battery5Bar",
    "Battery60",
    "Battery6Bar",
    "Battery80",
    "Battery90",
    "BatteryAlert",
    "BatteryCharging20",
    "BatteryCharging30",
    "BatteryCharging50",
    "BatteryCharging60",
    "BatteryCharging80",
    "BatteryCharging90",
    "BatteryChargingFull",
    "BatteryFull",
    "BatterySaver",
    "BatteryStd",
    "BatteryUnknown",
    "BeachAccess",
    "Bed",
    "BedroomBaby",
    "BedroomChild",
    "BedroomParent",
    "Bedtime",
    "Beenhere",
    "Bento",
    "BikeScooter",
    "Biotech",
    "Blender",
    "Block",
    "Bloodtype",
    "Bluetooth",
    "BluetoothAudio",
    "BluetoothConnected",
    "BluetoothDisabled",
    "BluetoothDrive",
    "BluetoothSearching",
    "BlurCircular",
    "BlurLinear",
    "BlurOff",
    "BlurOn",
    "Bolt",
    "Book",
    "BookOnline",
    "Bookmark",
    "BookmarkAdd",
    "BookmarkAdded",
    "BookmarkBorder",
    "BookmarkRemove",
    "Bookmarks",
    "BorderAll",
    "BorderBottom",
    "BorderClear",
    "BorderColor",
    "BorderHorizontal",
    "BorderInner",
    "BorderLeft",
    "BorderOuter",
    "BorderRight",
    "BorderStyle",
    "BorderTop",
    "BorderVertical",
    "BrandingWatermark",
    "BreakfastDining",
    "Brightness1",
    "Brightness2",
    "Brightness3",
    "Brightness4",
    "Brightness5",
    "Brightness6",
    "Brightness7",
    "BrightnessAuto",
    "BrightnessHigh",
    "BrightnessLow",
    "BrightnessMedium",
    "BrokenImage",
    "BrowserNotSupported",
    "BrunchDining",
    "Brush",
    "BubbleChart",
    "BugReport",
    "Build",
    "BuildCircle",
    "Bungalow",
    "BurstMode",
    "BusAlert",
    "Business",
    "BusinessCenter",
    "Cabin",
    "Cable",
    "Cached",
    "Cake",
    "Calculate",
    "CalendarToday",
    "CalendarViewDay",
    "CalendarViewMonth",
    "CalendarViewWeek",
    "Call",
    "CallEnd",
    "CallMade",
    "CallMerge",
    "CallMissed",
    "CallMissedOutgoing",
    "CallReceived",
    "CallSplit",
    "CallToAction",
    "Camera",
    "CameraAlt",
    "CameraEnhance",
    "CameraFront",
    "CameraIndoor",
    "CameraOutdoor",
    "CameraRear",
    "CameraRoll",
    "Cameraswitch",
    "Campaign",
    "Cancel",
    "CancelPresentation",
    "CancelScheduleSend",
    "CancelScheduleSend",
    "CardGiftcard",
    "CardMembership",
    "CardTravel",
    "Carpenter",
    "CarRental",
    "CarRepair",
    "Cases",
    "Casino",
    "Cast",
    "CastConnected",
    "CastForEducation",
    "CatchingPokemon",
    "Category",
    "Celebration",
    "CellWifi",
    "CenterFocusStrong",
    "CenterFocusWeak",
    "Chair",
    "ChairAlt",
    "Chalet",
    "ChangeCircle",
    "ChangeHistory",
    "ChargingStation",
    "Chat",
    "ChatBubble",
    "ChatBubbleOutline",
    "Check",
    "CheckBox",
    "CheckBoxOutlineBlank",
    "CheckCircle",
    "CheckCircleOutline",
    "Checklist",
    "ChecklistRtl",
    "Checkroom",
    "ChevronLeft",
    "ChevronRight",
    "ChildCare",
    "ChildFriendly",
    "ChromeReaderMode",
    "Circle",
    "CircleNotifications",
    "Class",
    "CleanHands",
    "CleaningServices",
    "Clear",
    "ClearAll",
    "Close",
    "CloseFullscreen",
    "ClosedCaption",
    "ClosedCaptionDisabled",
    "ClosedCaptionOff",
    "CloseFullscreen",
    "Cloud",
    "CloudCircle",
    "CloudDone",
    "CloudDownload",
    "CloudOff",
    "CloudQueue",
    "CloudUpload",
    "Code",
    "CodeOff",
    "Coffee",
    "CoffeeMaker",
    "Collections",
    "CollectionsBookmark",
    "ColorLens",
    "Colorize",
    "Comment",
    "CommentBank",
    "Commute",
    "Compare",
    "CompareArrows",
    "CompassCalibration",
    "Compost",
    "Compress",
    "Computer",
    "ConfirmationNumber",
    "ConnectWithoutContact",
    "ConnectedTv",
    "Construction",
    "ContactMail",
    "ContactPage",
    "ContactPhone",
    "ContactSupport",
    "Contactless",
    "Contacts",
    "ContentCopy",
    "ContentCut",
    "ContentPaste",
    "ContentPasteOff",
    "ControlCamera",
    "ControlPoint",
    "ControlPointDuplicate",
    "CopyAll",
    "CopyEmail",
    "CopyEmailRtl",
    "CopyLink",
    "CopyRight",
    "CopyToClipboard",
    "Coronavirus",
    "CorporateFare",
    "Cottage",
    "Countertops",
    "Create",
    "CreateNewFolder",
    "CreditCard",
    "CreditCardOff",
    "Crop",
    "Crop169",
    "Crop32",
    "Crop54",
    "Crop75",
    "CropDin",
    "CropFree",
    "CropLandscape",
    "CropOriginal",
    "CropPortrait",
    "CropRotate",
    "CropSquare",
    "CrueltyFree",
    "Dangerous",
    "DarkMode",
    "Dashboard",
    "DashboardCustomize",
    "DataExploration",
    "DataSaverOff",
    "DataSaverOn",
    "DataUsage",
    "DateRange",
    "Deck",
    "Dehaze",
    "Delete",
    "DeleteForever",
    "DeleteOutline",
    "DeleteSweep",
    "DeliveryDining",
    "DepartureBoard",
    "Description",
    "DesignServices",
    "DesktopAccessDisabled",
    "DesktopMac",
    "DesktopWindows",
    "Details",
    "DeveloperBoard",
    "DeveloperMode",
    "DeviceHub",
    "DeviceThermostat",
    "DeviceUnknown",
    "Devices",
    "DevicesOther",
    "DialerSip",
    "Dialpad",
    "Dining",
    "DinnerDining",
    "Directions",
    "DirectionsBike",
    "DirectionsBoat",
    "DirectionsBus",
    "DirectionsCar",
    "DirectionsOff",
    "DirectionsRailway",
    "DirectionsRun",
    "DirectionsSubway",
    "DirectionsTransit",
    "DirectionsWalk",
    "DirtyLens",
    "DisabledByDefault",
    "DisabledVisible",
    "DiscFull",
    "Dns",
    "Dock",
    "DocumentScanner",
    "Domain",
    "DomainDisabled",
    "DomainVerification",
    "Done",
    "DoneAll",
    "DoneOutline",
    "DonutLarge",
    "DonutSmall",
    "DoorBack",
    "DoorFront",
    "DoorSliding",
    "DoubleArrow",
    "DownhillSkiing",
    "Download",
    "DownloadDone",
    "DownloadForOffline",
    "Downloading",
    "Drafts",
    "DragHandle",
    "DragIndicator",
    "Draw",
    "DriveEta",
    "DriveFileMove",
    "DriveFileMoveOutline",
    "DriveFileMoveRtl",
    "DriveFileRenameOutline",
    "DriveFolderUpload",
    "Dry",
    "DryCleaning",
    "Duo",
    "Dvr",
    "DynamicFeed",
    "DynamicForm",
    "East",
    "Eco",
    "Edit",
    "EditAttributes",
    "EditCalendar",
    "EditLocation",
    "EditLocationAlt",
    "EditNote",
    "EditNotifications",
    "EditOff",
    "EditRoad",
    "Eject",
    "ElectricBike",
    "ElectricCar",
    "ElectricMoped",
    "ElectricRickshaw",
    "ElectricScooter",
    "Elevator",
    "Email",
    "Emergency",
    "Eject",
    "EnhancedEncryption",
    "Equalizer",
    "Equals",
    "Error",
    "ErrorOutline",
    "Escalator",
    "EscalatorWarning",
    "Euro",
    "EuroSymbol",
    "Event",
    "EventAvailable",
    "EventBusy",
    "EventNote",
    "EventSeat",
    "EvStation",
    "ExitToApp",
    "Expand",
    "ExpandLess",
    "ExpandMore",
    "Explicit",
    "Explore",
    "ExploreOff",
    "Exposure",
    "ExposureNeg1",
    "ExposureNeg2",
    "ExposurePlus1",
    "ExposurePlus2",
    "ExposureZero",
    "Extension",
    "ExtensionOff",
    "ExtensionRemove",
    "Face",
    "FaceRetouchingNatural",
    "Facebook",
    "FactCheck",
    "FamilyRestroom",
    "FastForward",
    "FastRewind",
    "Fastfood",
    "Favorite",
    "FavoriteBorder",
    "FeaturedPlayList",
    "FeaturedVideo",
    "Feed",
    "Feedback",
    "Female",
    "Fence",
    "Festival",
    "FiberDvr",
    "FiberManualRecord",
    "FiberNew",
    "FiberPin",
    "FiberSmartRecord",
    "FileCopy",
    "FileDownload",
    "FileDownloadDone",
    "FileDownloadOff",
    "Filter",
    "Filter1",
    "Filter2",
    "Filter3",
    "Filter4",
    "Filter5",
    "Filter6",
    "Filter7",
    "Filter8",
    "Filter9",
    "Filter9Plus",
    "FilterAlt",
    "FilterBAndW",
    "FilterCenterFocus",
    "FilterDrama",
    "FilterFrames",
    "FilterHdr",
    "FilterList",
    "FilterNone",
    "FilterTiltShift",
    "FilterVintage",
    "FindInPage",
    "FindReplace",
    "Fingerprint",
    "FireExtinguisher",
    "Fireplace",
    "FirstPage",
    "FitScreen",
    "FitnessCenter",
    "Flag",
    "Flaky",
    "Flare",
    "FlashAuto",
    "FlashOff",
    "FlashOn",
    "Flight",
    "FlightLand",
    "FlightTakeoff",
    "Flip",
    "FlipCameraAndroid",
    "FlipCameraIos",
    "FlipToBack",
    "FlipToFront",
    "Folder",
    "FolderOpen",
    "FolderShared",
    "FolderSpecial",
    "FollowTheSigns",
    "FontDownload",
    "FontDownloadOff",
    "FoodBank",
    "FormatAlignCenter",
    "FormatAlignJustify",
    "FormatAlignLeft",
    "FormatAlignRight",
    "FormatBold",
    "FormatClear",
    "FormatColorFill",
    "FormatColorReset",
    "FormatColorText",
    "FormatIndentDecrease",
    "FormatIndentIncrease",
    "FormatItalic",
    "FormatLineSpacing",
    "FormatListBulleted",
    "FormatListNumbered",
    "FormatListNumberedRtl",
    "FormatPaint",
    "FormatQuote",
    "FormatShapes",
    "FormatSize",
    "FormatStrikethrough",
    "FormatTextdirectionLToR",
    "FormatTextdirectionRToL",
    "FormatUnderlined",
    "FormatUnderlined",
    "Forum",
    "Forward",
    "Forward10",
    "Forward30",
    "Forward5",
    "FreeBreakfast",
    "Fullscreen",
    "FullscreenExit",
    "Functions",
    "GTranslate",
    "Gamepad",
    "Games",
    "Garage",
    "Gavel",
    "GeneratingTokens",
    "Gesture",
    "GetApp",
    "Gif",
    "Gite",
    "GolfCourse",
    "GppBad",
    "GppGood",
    "GppMaybe",
    "GpsFixed",
    "GpsNotFixed",
    "GpsOff",
    "Grade",
    "Gradient",
    "Grading",
    "Grain",
    "GraphicEq",
    "Grass",
    "GridOff",
    "GridOn",
    "Grid3X3",
    "Grid4X4",
    "GridGoldenratio",
    "GridOff",
    "GridView",
    "Group",
    "GroupAdd",
    "GroupOff",
    "GroupRemove",
    "GroupWork",
    "Hail",
    "Handyman",
    "Hardware",
    "Hd",
    "HdrOff",
    "HdrOn",
    "HdrStrong",
    "HdrWeak",
    "Headset",
    "HeadsetMic",
    "HeadsetOff",
    "Healing",
    "HealthAndSafety",
    "Hearing",
    "HearingDisabled",
    "Height",
    "Help",
    "HelpCenter",
    "HelpOutline",
    "Highlight",
    "HighlightAlt",
    "HighlightOff",
    "HighQuality",
    "Hiking",
    "History",
    "HistoryEdu",
    "HistoryToggleOff",
    "Home",
    "HomeRepairService",
    "HomeWork",
    "HorizontalDistribute",
    "HorizontalRule",
    "HorizontalSplit",
    "Hotel",
    "HotelClass",
    "HotTub",
    "HourglassBottom",
    "HourglassDisabled",
    "HourglassEmpty",
    "HourglassFull",
    "HourglassTop",
    "House",
    "HouseSiding",
    "HowToReg",
    "HowToVote",
    "Http",
    "Https",
    "Hvac",
    "Icecream",
    "Image",
    "ImageAspectRatio",
    "ImageNotSupported",
    "ImageSearch",
    "ImportContacts",
    "ImportExport",
    "ImportantDevices",
    "Inbox",
    "IndeterminateCheckBox",
    "Info",
    "Input",
    "InsertChart",
    "InsertChartOutlined",
    "InsertComment",
    "InsertDriveFile",
    "InsertEmoticon",
    "InsertInvitation",
    "InsertLink",
    "InsertPhoto",
    "Insights",
    "IntegrationInstructions",
    "Inventory",
    "InvertColors",
    "InvertColorsOff",
    "Iso",
    "Kayaking",
    "Keyboard",
    "KeyboardArrowDown",
    "KeyboardArrowLeft",
    "KeyboardArrowRight",
    "KeyboardArrowUp",
    "KeyboardBackspace",
    "KeyboardCapslock",
    "KeyboardHide",
    "KeyboardReturn",
    "KeyboardTab",
    "KeyboardVoice",
    "KingBed",
    "Kitchen",
    "Kitesurfing",
    "Label",
    "LabelImportant",
    "LabelImportantOutline",
    "LabelOff",
    "Landscape",
    "Language",
    "Laptop",
    "LaptopChromebook",
    "LaptopMac",
    "LaptopWindows",
    "LastPage",
    "Launch",
    "Layers",
    "LayersClear",
    "Leaderboard",
    "LeakAdd",
    "LeakRemove",
    "LegendToggle",
    "Lens",
    "LensBlur",
    "LibraryAdd",
    "LibraryAddCheck",
    "LibraryBooks",
    "LibraryMusic",
    "Light",
    "Lightbulb",
    "LightMode",
    "LineStyle",
    "LineWeight",
    "LinearScale",
    "Link",
    "LinkedCamera",
    "LinkOff",
    "Liquor",
    "List",
    "ListAlt",
    "LiveHelp",
    "LiveTv",
    "Living",
    "LocalActivity",
    "LocalAirport",
    "LocalAtm",
    "LocalBar",
    "LocalCafe",
    "LocalCarWash",
    "LocalConvenienceStore",
    "LocalDining",
    "LocalDrink",
    "LocalFireDepartment",
    "LocalFlorist",
    "LocalGasStation",
    "LocalGroceryStore",
    "LocalHospital",
    "LocalHotel",
    "LocalLaundryService",
    "LocalLibrary",
    "LocalMall",
    "LocalMovies",
    "LocalOffer",
    "LocalParking",
    "LocalPharmacy",
    "LocalPhone",
    "LocalPizza",
    "LocalPlay",
    "LocalPolice",
    "LocalPostOffice",
    "LocalPrintshop",
    "LocalSee",
    "LocalShipping",
    "LocalTaxi",
    "LocationCity",
    "LocationDisabled",
    "LocationHistory",
    "LocationOff",
    "LocationOn",
    "LocationPin",
    "LocationSearching",
    "Lock",
    "LockClock",
    "LockOpen",
    "LockOutline",
    "Login",
    "Logout",
    "Looks",
    "Looks3",
    "Looks4",
    "Looks5",
    "Looks6",
    "LooksOne",
    "LooksTwo",
    "Loop",
    "Loupe",
    "Luggage",
    "LunchDining",
    "Mail",
    "MailOutline",
    "Map",
    "MapIos",
    "MapsUgc",
    "Margin",
    "MarkAsUnread",
    "MarkChatRead",
    "MarkChatUnread",
    "MarkEmailRead",
    "MarkEmailUnread",
    "Markunread",
    "MarkunreadMailbox",
    "Masks",
    "Maximize",
    "MediaBluetoothOff",
    "MediaBluetoothOn",
    "Mediation",
    "MedicalServices",
    "Medication",
    "MeetingRoom",
    "Memory",
    "Menu",
    "MenuBook",
    "MenuOpen",
    "MergeType",
    "Message",
    "Mic",
    "MicExternalOff",
    "MicExternalOn",
    "MicNone",
    "MicOff",
    "Microwave",
    "MilitaryTech",
    "Minimize",
    "MiscellaneousServices",
    "MissedVideoCall",
    "Mms",
    "MobileFriendly",
    "MobileOff",
    "MobileScreenShare",
    "Mode",
    "ModeComment",
    "ModeEdit",
    "ModelTraining",
    "MonetizationOn",
    "Money",
    "MoneyOff",
    "MoneyOffCsred",
    "Monitor",
    "MonochromePhotos",
    "Mood",
    "MoodBad",
    "Moped",
    "More",
    "MoreHoriz",
    "MoreTime",
    "MoreVert",
    "MotionPhotosAuto",
    "MotionPhotosOff",
    "MotionPhotosOn",
    "MotionPhotosPause",
    "MotionPhotosPaused",
    "Mouse",
    "MoveToInbox",
    "Movie",
    "MovieCreation",
    "MovieFilter",
    "Moving",
    "Mp",
    "MultilineChart",
    "MultipleStop",
    "Museum",
    "MusicNote",
    "MusicOff",
    "MusicVideo",
    "MyLocation",
    "Nat",
    "Nature",
    "NaturePeople",
    "NavigateBefore",
    "NavigateNext",
    "Navigation",
    "NearMe",
    "NearMeDisabled",
    "NetworkCell",
    "NetworkCheck",
    "NetworkLocked",
    "NetworkWifi",
    "NewLabel",
    "NewReleases",
    "NextPlan",
    "NextWeek",
    "Nfc",
    "Nightlife",
    "NightShelter",
    "NightsStay",
    "NoAccounts",
    "NoBackpack",
    "NoCell",
    "NoDrinks",
    "NoEncryption",
    "NoFlash",
    "NoFood",
    "NoLuggage",
    "NoMeals",
    "NoMeetingRoom",
    "NoPhotography",
    "NordicWalking",
    "North",
    "NorthEast",
    "NorthWest",
    "NoSim",
    "NoStroller",
    "NotAccessible",
    "Note",
    "NoteAdd",
    "Notes",
    "NotificationAdd",
    "NotificationImportant",
    "Notifications",
    "NotificationsActive",
    "NotificationsNone",
    "NotificationsOff",
    "NotificationsPaused",
    "NotInterested",
    "NotListedLocation",
    "NotStarted",
    "OfflineBolt",
    "OfflinePin",
    "OfflineShare",
    "OndemandVideo",
    "OnlinePrediction",
    "Opacity",
    "OpenInBrowser",
    "OpenInFull",
    "OpenInNew",
    "OpenWith",
    "OutdoorGrill",
    "OutgoingMail",
    "OutgoingMailOutline",
    "Outbox",
    "Outlet",
    "OutlinedFlag",
    "Padding",
    "Pages",
    "Pageview",
    "Paid",
    "Palette",
    "PanTool",
    "Panorama",
    "PanoramaFishEye",
    "PanoramaHorizontal",
    "PanoramaVertical",
    "PanoramaWideAngle",
    "Paragliding",
    "Park",
    "PartyMode",
    "Password",
    "Pattern",
    "Pause",
    "PauseCircle",
    "PauseCircleFilled",
    "PauseCircleOutline",
    "PausePresentation",
    "Payment",
    "Payments",
    "PedalBike",
    "Pending",
    "PendingActions",
    "People",
    "PeopleAlt",
    "PeopleOutline",
    "PermCameraMic",
    "PermContactCalendar",
    "PermDataSetting",
    "PermDeviceInformation",
    "PermIdentity",
    "PermMedia",
    "PermPhoneMsg",
    "PermScanWifi",
    "Person",
    "PersonAdd",
    "PersonAddAlt",
    "PersonAddAlt1",
    "PersonAddDisabled",
    "PersonalInjury",
    "PersonalVideo",
    "PersonOff",
    "PersonOutline",
    "PersonPin",
    "PersonRemove",
    "PersonRemoveAlt1",
    "PersonSearch",
    "Pets",
    "Phonelink",
    "PhonelinkErase",
    "PhonelinkLock",
    "PhonelinkOff",
    "Phone",
    "PhoneAndroid",
    "PhoneBluetoothSpeaker",
    "PhoneCallback",
    "PhoneDisabled",
    "PhoneEnabled",
    "PhoneForwarded",
    "PhoneInTalk",
    "PhoneIphone",
    "PhoneLocked",
    "PhoneMissed",
    "PhonePaused",
    "Photo",
    "PhotoAlbum",
    "PhotoCamera",
    "PhotoCameraBack",
    "PhotoCameraFront",
    "PhotoFilter",
    "PhotoLibrary",
    "PhotoSizeSelectActual",
    "PhotoSizeSelectLarge",
    "PhotoSizeSelectSmall",
    "Piano",
    "PianoOff",
    "PictureAsPdf",
    "PictureInPicture",
    "PictureInPictureAlt",
    "PieChart",
    "Pin",
    "PinDrop",
    "PinEnd",
    "PinInvoke",
    "PinOff",
    "PinSplit",
    "Pixelart",
    "Place",
    "Plagiarism",
    "PlayArrow",
    "PlayCircle",
    "PlayCircleFilled",
    "PlayCircleOutline",
    "PlayDisabled",
    "PlayForWork",
    "PlayLesson",
    "PlaylistAdd",
    "PlaylistAddCheck",
    "PlaylistPlay",
    "Plumbing",
    "Plus",
    "PlusOne",
    "Podcasts",
    "PointOfSale",
    "Policy",
    "Poll",
    "Pool",
    "PortableWifiOff",
    "Portrait",
    "PostAdd",
    "Power",
    "PowerInput",
    "PowerOff",
    "PowerSettingsNew",
    "PrecisionManufacturing",
    "PregnantWoman",
    "PresentToAll",
    "Preview",
    "PriceChange",
    "PriceCheck",
    "Print",
    "PrintDisabled",
    "PriorityHigh",
    "PrivacyTip",
    "PrivateConnectivity",
    "ProductionQuantityLimits",
    "Psychology",
    "Public",
    "PublicOff",
    "Publish",
    "PublishedWithChanges",
    "PushPin",
    "QrCode",
    "QrCode2",
    "QrCodeScanner",
    "QueryBuilder",
    "QueryStats",
    "QuestionAnswer",
    "Queue",
    "QueueMusic",
    "QueuePlayNext",
    "Quickreply",
    "Quiz",
    "Radar",
    "Radio",
    "RadioButtonChecked",
    "RadioButtonUnchecked",
    "RailwayAlert",
    "RamenDining",
    "RateReview",
    "RawOff",
    "RawOn",
    "ReadMore",
    "RealEstateAgent",
    "Receipt",
    "ReceiptLong",
    "RecentActors",
    "Recommend",
    "RecordVoiceOver",
    "Recycling",
    "Redeem",
    "Redo",
    "ReduceCapacity",
    "Refresh",
    "RememberMe",
    "Remove",
    "RemoveCircle",
    "RemoveCircleOutline",
    "RemoveDone",
    "RemoveFromQueue",
    "RemoveModerator",
    "RemoveRedEye",
    "RemoveShoppingCart",
    "Reorder",
    "Repeat",
    "RepeatOn",
    "RepeatOne",
    "RepeatOneOn",
    "Replay",
    "Replay10",
    "Replay30",
    "Replay5",
    "ReplayCircleFilled",
    "Reply",
    "ReplyAll",
    "Report",
    "ReportGmailerrorred",
    "ReportOff",
    "ReportProblem",
    "RequestPage",
    "RequestQuote",
    "ResetTv",
    "RestartAlt",
    "Restaurant",
    "RestaurantMenu",
    "Restore",
    "RestoreFromTrash",
    "RestorePage",
    "Reviews",
    "RiceBowl",
    "RingVolume",
    "Roofing",
    "Room",
    "RoomPreferences",
    "RoomService",
    "Rotate90DegreesCcw",
    "RotateLeft",
    "RotateRight",
    "RoundedCorner",
    "Router",
    "Rowing",
    "RssFeed",
    "Rsvp",
    "Rtt",
    "Rule",
    "RuleFolder",
    "RunCircle",
    "RunningWithErrors",
    "RvHookup",
    "SafetyDivider",
    "Sailing",
    "Sanitizer",
    "Satellite",
    "Save",
    "SaveAlt",
    "SavedSearch",
    "Savings",
    "Scanner",
    "ScatterPlot",
    "Schedule",
    "ScheduleSend",
    "Schema",
    "School",
    "Science",
    "Score",
    "ScreenLockLandscape",
    "ScreenLockPortrait",
    "ScreenLockRotation",
    "ScreenRotation",
    "ScreenSearchDesktop",
    "ScreenShare",
    "Sd",
    "SdCard",
    "SdCardAlert",
    "SdStorage",
    "Search",
    "SearchOff",
    "Security",
    "SecurityUpdate",
    "SecurityUpdateGood",
    "SecurityUpdateWarning",
    "Segment",
    "SelectAll",
    "SelfImprovement",
    "Sell",
    "Send",
    "SendAndArchive",
    "SendToMobile",
    "SensorDoor",
    "SensorWindow",
    "Sensors",
    "SensorsOff",
    "SentimentDissatisfied",
    "SentimentNeutral",
    "SentimentSatisfied",
    "SentimentSatisfiedAlt",
    "SentimentVeryDissatisfied",
    "SentimentVerySatisfied",
    "SetMeal",
    "Settings",
    "SettingsAccessibility",
    "SettingsApplications",
    "SettingsBackupRestore",
    "SettingsBluetooth",
    "SettingsBrightness",
    "SettingsCell",
    "SettingsEthernet",
    "SettingsInputAntenna",
    "SettingsInputComponent",
    "SettingsInputComposite",
    "SettingsInputHdmi",
    "SettingsInputSvideo",
    "SettingsOverscan",
    "SettingsPhone",
    "SettingsPower",
    "SettingsRemote",
    "SettingsSuggest",
    "SettingsSystemDaydream",
    "SettingsVoice",
    "SettingsVpn",
    "Share",
    "ShareArrivalTime",
    "ShareLocation",
    "Shield",
    "Shop",
    "Shop2",
    "ShoppingBag",
    "ShoppingBasket",
    "ShoppingCart",
    "ShopTwo",
    "Shortcut",
    "ShortText",
    "ShowChart",
    "Shower",
    "Shuffle",
    "ShuffleOn",
    "ShutterSpeed",
    "Sick",
    "SignalCellular0Bar",
    "SignalCellular1Bar",
    "SignalCellular2Bar",
    "SignalCellular3Bar",
    "SignalCellular4Bar",
    "SignalCellularAlt",
    "SignalCellularConnectedNoInternet0Bar",
    "SignalCellularConnectedNoInternet1Bar",
    "SignalCellularConnectedNoInternet2Bar",
    "SignalCellularConnectedNoInternet3Bar",
    "SignalCellularConnectedNoInternet4Bar",
    "SignalCellularNoSim",
    "SignalCellularNull",
    "SignalCellularOff",
    "SignalWifi0Bar",
    "SignalWifi1Bar",
    "SignalWifi1BarLock",
    "SignalWifi2Bar",
    "SignalWifi2BarLock",
    "SignalWifi3Bar",
    "SignalWifi3BarLock",
    "SignalWifi4Bar",
    "SignalWifi4BarLock",
    "SignalWifiBad",
    "SignalWifiConnectedNoInternet0",
    "SignalWifiConnectedNoInternet1",
    "SignalWifiConnectedNoInternet2",
    "SignalWifiConnectedNoInternet3",
    "SignalWifiConnectedNoInternet4",
    "SignalWifiOff",
    "SimCard",
    "SimCardAlert",
    "SimCardDownload",
    "SingleBed",
    "Sip",
    "Skateboarding",
    "SkipNext",
    "SkipPrevious",
    "Sledding",
    "Slideshow",
    "SlowMotionVideo",
    "SmartButton",
    "SmartDisplay",
    "SmartScreen",
    "SmartToy",
    "SmokeFree",
    "SmokingRooms",
    "Sms",
    "SmsFailed",
    "SnippetFolder",
    "Snooze",
    "Snowboarding",
    "Snowmobile",
    "Snowshoeing",
    "Soap",
    "SocialDistance",
    "Sort",
    "SortByAlpha",
    "Source",
    "South",
    "SouthEast",
    "SouthWest",
    "Spa",
    "SpaceDashboard",
    "SpaceDashboard",
    "SpaceDashboard",
    "Speaker",
    "SpeakerGroup",
    "SpeakerNotes",
    "SpeakerNotesOff",
    "SpeakerPhone",
    "Speed",
    "Spellcheck",
    "Sport",
    "Sports",
    "SportsBar",
    "SportsBaseball",
    "SportsBasketball",
    "SportsCricket",
    "SportsEsports",
    "SportsFootball",
    "SportsGolf",
    "SportsHandball",
    "SportsHockey",
    "SportsKabaddi",
    "SportsMma",
    "SportsMotorsports",
    "SportsRugby",
    "SportsSoccer",
    "SportsTennis",
    "SportsVolleyball",
    "SquareFoot",
    "StackedLineChart",
    "Stairs",
    "Star",
    "StarBorder",
    "StarHalf",
    "StarOutline",
    "StarRate",
    "Stars",
    "StayCurrentLandscape",
    "StayCurrentPortrait",
    "StayPrimaryLandscape",
    "StayPrimaryPortrait",
    "StickyNote2",
    "Stop",
    "StopCircle",
    "StopScreenShare",
    "Storage",
    "Store",
    "Storefront",
    "StoreMallDirectory",
    "Storm",
    "Straighten",
    "Stream",
    "Streetview",
    "StrikethroughS",
    "Stroller",
    "Style",
    "SubdirectoryArrowLeft",
    "SubdirectoryArrowRight",
    "Subject",
    "Subscript",
    "Subscriptions",
    "Subtitles",
    "SubtitlesOff",
    "SubtitlesOff",
    "Subway",
    "Summarize",
    "Superscript",
    "SupervisedUserCircle",
    "SupervisorAccount",
    "Support",
    "SupportAgent",
    "Surfing",
    "SurroundSound",
    "SwapCalls",
    "SwapHoriz",
    "SwapHorizontalCircle",
    "SwapVert",
    "SwapVerticalCircle",
    "Swipe",
    "SwitchAccount",
    "SwitchCamera",
    "SwitchLeft",
    "SwitchRight",
    "SwitchVideo",
    "Sync",
    "SyncAlt",
    "SyncDisabled",
    "SyncProblem",
    "SystemSecurityUpdate",
    "SystemSecurityUpdateGood",
    "SystemSecurityUpdateWarning",
    "SystemUpdate",
    "SystemUpdateAlt",
    "Tab",
    "TabUnselected",
    "Tablet",
    "TabletAndroid",
    "TabletMac",
    "Tag",
    "TagFaces",
    "TakeoutDining",
    "TapAndPlay",
    "Tapas",
    "Task",
    "TaskAlt",
    "TaxiAlert",
    "Terrain",
    "TextFields",
    "TextFormat",
    "TextRotateUp",
    "TextRotateVertical",
    "TextRotationAngledown",
    "TextRotationAngleup",
    "TextRotationDown",
    "TextRotationNone",
    "Textsms",
    "TextSnippet",
    "Texture",
    "TheaterComedy",
    "Theaters",
    "ThumbDown",
    "ThumbsUpDown",
    "ThumbUp",
    "TimeToLeave",
    "Timelapse",
    "Timeline",
    "Timer",
    "Timer10",
    "Timer3",
    "TimerOff",
    "TimeToLeave",
    "Title",
    "Toc",
    "Today",
    "ToggleOff",
    "ToggleOn",
    "Toll",
    "Tonality",
    "Topic",
    "TouchApp",
    "Tour",
    "Toys",
    "TrackChanges",
    "Traffic",
    "Train",
    "Tram",
    "TransferWithinAStation",
    "Transform",
    "Transgender",
    "TransitEnterexit",
    "Translate",
    "TravelExplore",
    "TrendingDown",
    "TrendingFlat",
    "TrendingNeutral",
    "TrendingUp",
    "TripOrigin",
    "Try",
    "Tty",
    "Tune",
    "Tungsten",
    "TurnedIn",
    "TurnedInNot",
    "Tv",
    "TvOff",
    "TwoWheeler",
    "Umbrella",
    "Unarchive",
    "Undo",
    "UnfoldLess",
    "UnfoldMore",
    "Unpublished",
    "Unsubscribe",
    "Upcoming",
    "Update",
    "UpdateDisabled",
    "Upgrade",
    "Upload",
    "UploadFile",
    "Usb",
    "UsbOff",
    "Verified",
    "VerifiedUser",
    "VerticalAlignBottom",
    "VerticalAlignCenter",
    "VerticalAlignTop",
    "VerticalDistribute",
    "VerticalSplit",
    "Vibration",
    "VideoCall",
    "Videocam",
    "VideoCameraBack",
    "VideoCameraFront",
    "VideocamOff",
    "VideoCollection",
    "VideoLabel",
    "VideoLibrary",
    "VideoSettings",
    "VideoStable",
    "VideogameAsset",
    "VideogameAssetOff",
    "ViewAgenda",
    "ViewArray",
    "ViewCarousel",
    "ViewColumn",
    "ViewComfortable",
    "ViewComfy",
    "ViewCompact",
    "ViewDay",
    "ViewHeadline",
    "ViewInAr",
    "ViewList",
    "ViewModule",
    "ViewQuilt",
    "ViewSidebar",
    "ViewStream",
    "ViewWeek",
    "Vignette",
    "Visibility",
    "VisibilityOff",
    "VoiceChat",
    "Voicemail",
    "VoiceOverOff",
    "VolumeDown",
    "VolumeMute",
    "VolumeOff",
    "VolumeUp",
    "VolunteerActivism",
    "VpnKey",
    "Vrpano",
    "Wallpaper",
    "Warning",
    "WarningAmber",
    "Wash",
    "Watch",
    "Warehouse",
    "WatchLater",
    "Water",
    "WaterDamage",
    "WaterDrop",
    "WaterfallChart",
    "Waves",
    "WbAuto",
    "WbCloudy",
    "WbIncandescent",
    "WbIridescent",
    "WbShade",
    "WbSunny",
    "WbTwilight",
    "Wc",
    "Web",
    "WebAsset",
    "WebAssetOff",
    "Weekend",
    "West",
    "Whatshot",
    "WheelchairPickup",
    "WhereToVote",
    "Widgets",
    "Wifi",
    "WifiCalling",
    "WifiCalling3",
    "WifiLock",
    "WifiOff",
    "WifiProtectedSetup",
    "WifiTethering",
    "WifiTetheringErrorRounded",
    "WifiTetheringOff",
    "Window",
    "WineBar",
    "Work",
    "WorkOff",
    "WorkOutline",
    "Workspaces",
    "WrapText",
    "WrongLocation",
    "Wysiwyg",
    "YoutubeSearchedFor",
    "ZoomIn",
    "ZoomOut",
    "ZoomOutMap"
]